import IndexPanelContainer from './IndexPanelContainer';

export default IndexPanelContainer;
